<template>
  <NBox
    class="flex flex-col py-3 bg-cover bg-blend-multiply w-full h-auto px-3 mt-2 mb-3 gap-3"
  >
    <div class="flex items-center justify-between">
      <NText variant="caption1" weight="medium" class="text-neutral-primary">{{
        generateBankInfo.bankTitle
      }}</NText>
      <NText
        variant="caption1"
        weight="medium"
        class="text-neutral-secondary"
        >{{ generateBankInfo.bankBranchName }}</NText
      >
    </div>
    <div class="flex items-center justify-between">
      <NText
        variant="caption1"
        weight="medium"
        class="text-neutral-secondary"
        >{{ t('withdrawal.accountNumber') }}</NText
      >
      <div
        class="flex items-center gap-1 cursor-pointer"
        @click="() => copyTextInClipboard(generateBankInfo.accountCode)"
      >
        <NText variant="caption1" weight="bold" class="text-brand-primary">{{
          generateBankInfo.accountCode
        }}</NText>
        <NegarTileIcon class="text-brand-primary" size="16" />
      </div>
    </div>

    <div class="flex items-center justify-between">
      <NText
        variant="caption1"
        weight="medium"
        class="text-neutral-secondary"
        >{{ t('withdrawal.shebaNumber') }}</NText
      >
      <div
        class="flex items-center gap-1 cursor-pointer"
        @click="() => copyTextInClipboard(generateBankInfo.sheba)"
      >
        <NText variant="caption1" weight="bold" class="text-brand-primary">{{
          generateBankInfo.sheba
        }}</NText>
        <NegarTileIcon class="text-brand-primary" size="16" />
      </div>
    </div>
  </NBox>
</template>

<script setup lang="ts">
import { NBox, NText, useToast } from '@negar/core';
import { useI18n } from 'vue-i18n';
import { NegarTileIcon } from '@negar/icons';

const { t } = useI18n();
const toast = useToast();

type TypegenerateBankInfo = {
  generateBankInfo: {
    title: string;
    bankTitle: string;
    accountId: number;
    accountCode: string;
    bankBranchName: string;
    sheba: string;
  };
};
defineProps<TypegenerateBankInfo>();

const copyTextInClipboard = (text: string) => {
  navigator?.clipboard?.writeText(text).then(() =>
    toast.neutral({
      message: t('withdrawal.copiedNumber'),
      duration: 5000,
    })
  );
};
</script>
